export const AnamneseIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.3335 1.33325H2.66683V14.6666H1.3335V1.33325ZM14.0002 8.66659H4.66683C4.49002 8.66659 4.32045 8.73682 4.19543 8.86185C4.0704 8.98687 4.00016 9.15644 4.00016 9.33325V12.6666C4.00016 12.8434 4.0704 13.013 4.19543 13.138C4.32045 13.263 4.49002 13.3333 4.66683 13.3333H14.0002C14.177 13.3333 14.3465 13.263 14.4716 13.138C14.5966 13.013 14.6668 12.8434 14.6668 12.6666V9.33325C14.6668 9.15644 14.5966 8.98687 14.4716 8.86185C14.3465 8.73682 14.177 8.66659 14.0002 8.66659ZM13.3335 11.9999H5.3335V9.99992H13.3335V11.9999ZM4.66683 7.33325H11.3335C11.5103 7.33325 11.6799 7.26301 11.8049 7.13799C11.9299 7.01297 12.0002 6.8434 12.0002 6.66659V3.33325C12.0002 3.15644 11.9299 2.98687 11.8049 2.86185C11.6799 2.73682 11.5103 2.66659 11.3335 2.66659H4.66683C4.49002 2.66659 4.32045 2.73682 4.19543 2.86185C4.0704 2.98687 4.00016 3.15644 4.00016 3.33325V6.66659C4.00016 6.8434 4.0704 7.01297 4.19543 7.13799C4.32045 7.26301 4.49002 7.33325 4.66683 7.33325ZM5.3335 3.99992H10.6668V5.99992H5.3335V3.99992Z"
        fill="currentColor"
      />
    </svg>
  );
};
